module.exports = __webpack_public_path__ + "media/images/riders/small/AMAURY_PIERRON-01566664568648d6fecded0f924a08ba.png";